import React from 'react';
import { useNavigate } from 'react-router';

const Hero = ({
	backgroundColor,
	primaryColor,
	secondaryColor,
	tertiaryColor,
	quaternaryColor,
	title,
	subTitle,
	imageUrl,
	btntxt,
	btnUrl,
	btntxt2,
	btnUrl2
}) => {
	const navigate = useNavigate();

	const handleNavigation = url => {
		if (url.startsWith('https://')) {
			window.open(url, '_blank');
		} else {
			navigate(url);
		}
	};
	
	return (
		<>
			<section style={{ backgroundColor: backgroundColor }}>
				<div className="grid max-w-screen-xl px-12 py-24 mx-auto md:gap-24 lg:gap-0 md:py-48 md:grid-cols-12">
					<div className="mr-auto place-self-center md:col-span-7">
						<h1
							className="max-w-2xl mb-12 text-4xl font-extrabold tracking-tight leading-none sm:text-5xl lg:text-6xl"
							style={{ color: tertiaryColor }}
						>
							{title}
						</h1>
						<p
							className="max-w-2xl mb-18 font-light md:mb-24 sm:text-lg md:text-xl"
							style={{ color: quaternaryColor }}
						>
							{subTitle}
						</p>
						<button
							onClick={() => handleNavigation(btnUrl)}
							className="inline-flex items-center justify-center px-16 py-9 mr-9 text-base font-medium text-center text-white rounded-lg hover:bg-primary-800 focus:ring-4 focus:ring-primary-300"
							style={{ backgroundColor: primaryColor }}
						>
							{btntxt}
							<svg
								className="w-14 h-14 ml-6 -mr-1"
								fill="currentColor"
								viewBox="0 0 20 20"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									fillRule="evenodd"
									d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
									clipRule="evenodd"
								></path>
							</svg>
						</button>
						<button
							onClick={() => handleNavigation(btnUrl2)}
							className="inline-flex items-center justify-center px-16 py-9 text-base font-medium text-center border border-gray-300 rounded-lg hover:bg-gray-100 focus:ring-4 focus:ring-gray-100"
							style={{ backgroundColor: secondaryColor, color: tertiaryColor }}
						>
							{btntxt2}
						</button>
					</div>
					<div className="hidden md:mt-0 md:col-span-5 md:flex">
						<img src={imageUrl} alt="mockup" />
					</div>
				</div>
			</section>
		</>
	);
};

export default Hero;
